"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "fr": {
        "translation": {
            "page_header": {
                "example": "Exemple",
                "icons": {
                    "academy": "Académie",
                    "asset_inventory": "Stock d'actifs",
                    "assets_and_attributes": "Actifs et attributs",
                    "assurance_plans": "Plans d'assurance",
                    "bulk_importer": "Assistant d'importation en bloc",
                    "compliance_maps": "Cartes de conformité",
                    "community": "Communauté",
                    "frameworks": "Cadres",
                    "issue_tracker": "Outil de suivi des problèmes",
                    "launchpad": "Barre de lancement",
                    "mission_control": "Suivi des contrôles",
                    "projects": "Projets",
                    "reports": "Rapports",
                    "results": "Résultats",
                    "robots": "Robots",
                    "scheduler": "Planificateur",
                    "storyboard": "Storyboards",
                    "strategy": "Stratégie",
                    "task_tracker": "Outil de suivi des tâches",
                    "time_sheets": "Relevés de temps",
                    "toolkits": "Kits de ressources"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=fr.js.map